import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import configurationSlice from './slices/configurationSlice';
import treatmentsSlice from './slices/treatmentsSlice';
import treatmentValidationSlice from './slices/treatmentValidationSlice';
import activityValidationSlice from './slices/activityValidationSlice';
import actualsTreatmentValidationSlice from './slices/actualsTreatmentValidationSlice';
import actualsActivityValidationSlice from './slices/actualsActivityValidationSlice';
import projectValidationSlice from './slices/projectValidationSlice';
import activitiesSlice from './slices/activitiesSlice';
import filterSlice from './slices/filterSlice';
import mapSlice from './slices/mapSlice';
import thunk from 'redux-thunk';
import customFilterSlice from './slices/customFilterSlice';
import actualsTreatmentsSlice from './slices/actualsTreatmentsSlice';
import actualsActivitiesSlice from './slices/actualsActivitiesSlice';
import menuSlice from './slices/menuSlice';
import globalOverridesSlice from './slices/globalOverridesSlice';
import globalContextSlice from './slices/globalContextSlice';
import detailsSlice from './slices/detailsSlice';
import displayStateSlice from './slices/displayStateSlice';
import errorSlice from './slices/errorSlice';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        'treatments',
        'activities',
        'actualsTreatments',
        'actualsActivities',
        'projects',
        'configuration',

        // The below slices are blacklisted as they come from the globalContext or propdrilling refactor.
        // Will address at a later time if entries need to be persisted through redux Persistor.
        'globalContext',
        'details',
        'displayState',
        'error',
    ],
};

const rootReducer = combineReducers({
    configuration: configurationSlice,
    map: mapSlice,
    filter: filterSlice,
    customFilter: customFilterSlice,
    treatments: treatmentsSlice,
    treatmentValidation: treatmentValidationSlice,
    activityValidation: activityValidationSlice,
    actualsTreatmentValidation: actualsTreatmentValidationSlice,
    actualsActivityValidation: actualsActivityValidationSlice,
    projectValidation: projectValidationSlice,
    activities: activitiesSlice,
    actualsTreatments: actualsTreatmentsSlice,
    actualsActivities: actualsActivitiesSlice,
    menu: menuSlice,
    globalOverrides: globalOverridesSlice,
    globalContext: globalContextSlice,
    details: detailsSlice,
    displayState: displayStateSlice,
    error: errorSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],
});

export default store;

// function to help with testing
export function setupStore(preloadedState: any) {
    return configureStore({
        reducer: persistedReducer,
        preloadedState,
        middleware: [thunk],
    });
}

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
